// src/utils/toaster.js
import { createToaster } from "@meforma/vue-toaster";

export const toast = createToaster({
  position: "top-right",
  duration: 3000,
});
